/**
 * Feature Flags Configuration
 *
 * Controls which features/modules are enabled in the application.
 * This allows for easy customization when building your app.
 *
 * To disable a feature:
 * - In development: Set VITE_FEATURE_[NAME]=false in .dev.vars
 * - In production: Set VITE_FEATURE_[NAME]=false in wrangler.jsonc vars
 *
 * Example .dev.vars:
 * VITE_FEATURE_STYLE_GUIDE=false   # Hide style guide in production
 */

// Helper to safely access import.meta.env (only available in Vite client builds)
const getEnv = (key: string): string | boolean | undefined => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key]
  }
  return undefined
}

// Helper function to check feature flag
// Returns true by default, false only if explicitly set to 'false'
const isEnabled = (envVar: string): boolean => {
  const value = getEnv(envVar)
  return value !== 'false'
}

export const features = {
  /**
   * User Preferences
   */

  /**
   * Theme Picker - Allow users to change color theme
   * Set to false to lock users to the default theme (for branded client sites)
   * Default theme is set in src/shared/schemas/preferences.schema.ts
   */
  themePicker: isEnabled('VITE_FEATURE_THEME_PICKER'),
} as const

export type Features = typeof features
